<template>
  <div class="flex p-1 bg-gray-700 cursor-default">
    <div class="flex flex-grow" v-if="tabs.isSelected('Tags')">
      <div
        v-for="(item,i) of selectedNodeParents"
        :key="i"
        class="text-xs flex items-center"
        style="margin-right:2px"
      >
        <div
          class="flex items-center z-10 text-gray-600 px-1 pr-2 rounded-r-full rounded-l"
          :class="[isSelectedNode(item) ? 'text-teal-100' : '']"
          style="margin-right:1px"
          @click="selectNode(item)"
        >
          <XIcon size="14" @click="deleteNode(item)" class="hover:text-red-200" />
          <div>{{item.localName}}</div>
        </div>
        <ChevronRightIcon size="14" style="margin-left:1px" v-if="i<selectedNodeParents.length-1" />
      </div>
    </div>
    <div class="flex flex-grow" v-if="tabs.isSelected('Classes')">
      <div class=" flex overflow-x-auto" style="width:55vw">
        <div
          v-for="(item,i) of selectedNodeClassList"
          :key="i"
          class="text-xs mr-1 px-1 flex items-center  text-teal-400"
        >
          <div @click="addClass(item)">
            <XIcon size="14" />
          </div>
          <div class="whitespace-no-wrap">{{item}}</div>
        </div>
      </div>
    </div>

    <div class="flex items-center text-xs cursor-default">
      <div
        class="mr-1 px-2 text-gray-300"
        v-for="(item,i) of tabs.tabs"
        :key="i"
        @click="tabs.select(item)"
        :class="[tabs.isSelected(item) ? 'bg-teal-500 text-gray-100': '' ]"
      >{{item}}</div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import { UiTabs } from "../../util";

export default {
  name: "VColorButton",
  props: {
    type: { default: "rounded-full" },
    color: { default: "" },
    text: { default: "" },
    tooltip: { default: "" },
    selected: { default: false }
  },
  data() {
    return {
      isShowTip: false,
      tabs: new UiTabs(["Tags", "Classes"])
    };
  },
  mounted() {
    this.tabs.select("Tags");
  },
  computed: {
    ...mapGetters([
      "selectedNodeClassList",
      "selectedNodeParents",
      "isSelectedNode"
    ])
  },
  methods: {
    ...mapActions(["addClass", "deleteNode", "selectNode"])
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.t-col {
  color: rgb(224, 227, 230);
}
.bg-tag {
  background: rgb(62, 61, 61);
}
.triangle {
  height: 0;
  width: 0;
  margin-left: -1px;
  border-left: 9px solid rgb(62, 61, 61);
  border-right: 9px solid transparent;
  border-bottom: 9px solid transparent;
  border-top: 9px solid transparent;
}
</style>
